export const AmenityV2Icon = {
  bathtub: require('./bathtub.svg'),
  shampoo: require('./shampoo.svg'),
  essentials: require('./essentials.svg'),
  dryer: require('./dryer.svg'),
  hangers: require('./hangers.svg'),
  towels_provided: require('./towels_provided.svg'),
  washer: require('./washer.svg'),
  cable_tv: require('./cable_tv.svg'),
  tv: require('./tv.svg'),
  stereo_system: require('./stereo_system.svg'),
  air_conditioning: require('./air_conditioning.svg'),
  heating: require('./heating.svg'),
  indoor_fireplace: require('./indoor_fireplace.svg'),
  fire_extinguisher: require('./fire_extinguisher.svg'),
  first_aid_kit: require('./first_aid_kit.svg'),
  smoke_detector: require('./smoke_detector.svg'),
  desk: require('./desk.svg'),
  wireless_internet: require('./wireless_internet.svg'),
  laptop_friendly_workspace: require('./laptop_friendly_workspace.svg'),
  coffee_maker: require('./coffee_maker.svg'),
  cookware: require('./cookware.svg'),
  dishes_and_silverware: require('./dishes_and_silverware.svg'),
  dishwasher: require('./dishwasher.svg'),
  kitchen: require('./kitchen.svg'),
  kettle: require('./kettle.svg'),
  microwave: require('./microwave.svg'),
  oven: require('./oven.svg'),
  refrigerator: require('./refrigerator.svg'),
  stove: require('./stove.svg'),
  toaster: require('./toaster.svg'),
  private_pool: require('./private_pool.svg'),
  garden_or_backyard: require('./garden_or_backyard.svg'),
  patio_or_balcony: require('./patio_or_balcony.svg'),
  bbq_grill: require('./bbq_grill.svg'),
  ev_charger: require('./ev_charger.svg'),
  free_parking_on_premises: require('./free_parking_on_street.svg'),
  doorman: require('./doorman.svg'),
  tub_with_shower_bench: require('./tub_with_shower_bench.svg'),
  elevator: require('./elevator.svg'),
  gym: require('./gym.svg'),
  hot_tub: require('./hot_tub.svg'),
  sauna: require('./sauna.svg'),
};
